<template>
  <div
    :style="`background: radial-gradient(${bgGradient});`"
    :class="{ 'hero-caroucel-item-customer--dimmed': !dimmed }"
    class="hero-caroucel-item-customer"
  >
    <div class="hero-caroucel-item-customer__container">
      <div class="hero-caroucel-item-customer__image">
        <img :src="personImage" alt="" />
      </div>
      <div class="hero-caroucel-item-customer__contents">
        <div class="hero-caroucel-item-customer__subtitle">
          <slot name="subtitle"></slot>
        </div>
        <div class="hero-caroucel-item-customer__title">
          <slot name="title"></slot>
        </div>
        <div class="hero-caroucel-item-customer__btn">
          <slot name="button"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgGradient: {
      type: String,
      required: true
    },
    personImage: {
      type: String,
      required: true
    },
    dimmed: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isMobile() {
      const mq = this.$mq
      return mq === 'thumb' || mq === 'pocket'
    }
  }
}
</script>

<style lang="scss">
.hero-caroucel-item-customer {
  position: relative;
  height: 460px;
  min-height: 460px;

  @include av-mq(lap-and-up) {
    height: 708px;
    min-height: 708px;
  }

  &__container {
    position: relative;
    max-width: 1024px;
    margin: 0 auto;
    height: 100%;
  }

  &__image {
    position: absolute;
    right: 1rem;
    top: 34%;
    z-index: 2;
    width: calc(40% - 1rem);

    @include av-mq(lap-and-up) {
      top: 24%;
    }
  }

  &__contents {
    position: absolute;
    left: 1rem;
    top: 35%;
    z-index: 2;

    @include av-mq(lap-and-up) {
      top: 35%;
    }
  }

  &__title {
    margin-bottom: 1rem;
    font-size: 26px;
    line-height: 1.4;
    color: #fff;
    text-shadow: 0px 0px 2px #333;
    word-break: keep-all;

    @include av-mq(lap-and-up) {
      margin-bottom: 2rem;
      font-size: 48px;
    }

    span {
      font-weight: bolder;
    }
  }

  &__subtitle {
    margin-bottom: 0.5rem;
    font-size: 16px;
    color: #fff;
    z-index: 2;
    font-weight: normal;

    @include av-mq(lap-and-up) {
      margin-bottom: 1rem;
      font-size: 24px;
    }
  }
}
</style>
